<!-- Section Bidon Pompe -->
<app-collapse
  [title]="'P0003606.status.bidonPompe' | translate"
  [warning]="getValue('iphSFinBidon') === 1"
>
  <div slot="contenu">
    @if (getValue('iphIDetecteurFinBidonInstalle') === 1) {
      <app-display-rubrique-status-with-warning
        [title]="'P0003606.status.bidon' | translate"
        [warning]="getValue('iphSFinBidon') === 1"
        [icon]="'fa-exclamation-triangle'"
        [text]="'P0003606.status.ok' | translate"
      />

      @if (isSupportTechnique()) {
        <app-display-rubrique-status
          [title]="'P0003606.status.etatContact' | translate"
          [value]="
            getValue('iphSEtatContactFinBidon') === 0
              ? ('P0003606.status.ferme' | translate)
              : ('P0003606.status.ouvert' | translate)
          "
        />
      }
    }

    <app-display-rubrique-status-on-off
      [title]="'P0003606.status.fonctionnementPompe' | translate"
      [value]="getValue('iphSEtatPompe') !== 0"
    />
  </div>
</app-collapse>

<!-- Section Traitement pH -->
<app-collapse
  [title]="'P0003606.status.traitementPh' | translate"
  [warning]="
    getValue('iphSProtectionSurdosage') === 1 ||
    getValue('iphSSecuritePh') === 1
  "
>
  <div slot="contenu">
    <app-display-rubrique-status
      [title]="'P0003606.status.detectionDebit' | translate"
      [value]="
        getValue('iphSArretInjection') === 0
          ? ('P0003606.status.oui' | translate)
          : ('P0003606.status.non' | translate)
      "
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P0003606.status.detectionDebitReference' | translate"
        [value]="
          getValue('iphSDetectionDebitReference') === 0
            ? ('P0003606.status.indisponible' | translate)
            : getValue('iphSDetectionDebitReference') === 1
              ? ('P0003606.status.absent' | translate)
              : ('P0003606.status.present' | translate)
        "
      />
    }

    <app-display-rubrique-status-with-warning-and-cta
      [title]="'P0003606.status.securiteSurdosage' | translate"
      [warning]="getValue('iphSProtectionSurdosage') === 1"
      [notWarning]="'-'"
      [ctaText]="'P0003606.status.securiteSurdosage.value' | translate"
      (onPress)="acknowledgeUtilisateur()"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status-with-warning-and-cta
        [title]="'P0003606.status.protectionSurdosage' | translate"
        [warning]="false"
        [notWarning]="getValue('iphSNombreTotalProtectionSurdosage') + ''"
        [ctaText]="'P0003606.status.resetCompteur' | translate"
        (onPress)="resetCompteur()"
      />
    }

    <app-display-rubrique-status-with-warning
      [title]="'P0003606.status.securitePh' | translate"
      [warning]="getValue('iphSSecuritePh') === 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="'-'"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status-on-off
        [title]="'P0003606.status.autoMaintienFiltration' | translate"
        [value]="getValue('iphSMiseEnRouteFiltration') !== 0"
      />

      <app-display-rubrique-status
        [title]="'P0003606.status.mesurePhRef' | translate"
        [value]="
          getValue('iphSMesurePhReferenceDisponible') === 0
            ? ('P0003606.status.indisponible' | translate)
            : ('P0003606.status.ok' | translate)
        "
      />
    }
  </div>
</app-collapse>

<!-- Section Produit -->
<app-collapse
  [title]="'P0003606.status.produit' | translate"
  [warning]="presenceProduit === 2"
>
  <div slot="contenu">
    <app-display-rubrique-status-with-warning
      [title]="'P0003606.status.connexionProduit' | translate"
      [warning]="presenceProduit !== 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="'P0003606.status.ok' | translate"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P0003606.status.nombreDeCommutationDuRelais' | translate"
        [value]="getValue('iphSNombreCommutationRelais') + ''"
      />

      <app-display-rubrique-status-on-off
        [title]="'P0003606.status.etatDuBouton' | translate"
        [value]="getValue('iphSEtatBouton') !== 0"
      />

      <app-display-rubrique-status
        [title]="'P0003606.status.compteurBouton' | translate"
        [value]="getValue('iphSCompteurBouton') + ''"
      />
    }
  </div>
</app-collapse>
